import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaLinkedin,
} from "react-icons/fa";
import logo from "../images/logo.jpg";

const quickLinks = [
  ["Hajj & Umrah", "#hajjumrah"],
  ["Visa", "#visas"],
  ["Hotels", "#hotels"],
  ["Air Tickets", "#airticket"],
  ["Gallery", "#gallery"],
  ["Contact", "#contact"],
];

const socials = [
  { Icon: FaFacebook, href: "https://www.facebook.com/CMSTours92" },
  { Icon: FaInstagram, href: "https://www.instagram.com/cmstoursandtravels" },
  { Icon: FaYoutube, href: "https://www.youtube.com/@CMSToursandTravelsOfficial" },
  { Icon: FaTiktok, href: "https://www.tiktok.com/@visionbyahmadraza" },
  { Icon: FaLinkedin, href: "https://www.linkedin.com/company/chalomakkahshariftourstravelpvtltd/" },
];

const Footer = () => {
  return (
    <footer className="border-t-2 border-brand-gold/40 bg-gradient-to-b from-brand-dark to-[#072414] text-white">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-6 py-20 sm:grid-cols-2 md:grid-cols-3">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3">
            <img src={logo} alt="Chalo Makkah Sharif" className="h-16 w-16 rounded-full object-cover shadow-soft" />
            <span className="leading-tight">
              <span className="block text-lg font-extrabold">
                <span className="text-brand-green">CHALO</span> MAKKAH SHARIF
              </span>
              <span className="block text-[11px] font-semibold uppercase tracking-[2px] text-brand-orange">
                Tours &amp; Travels
              </span>
            </span>
          </div>
          <p className="mt-5 max-w-xs text-base text-white/70">
            Your journey, our commitment — trusted Hajj, Umrah and travel services since 2005.
          </p>
        </div>

        {/* Quick links */}
        <div>
          <h4 className="mb-4 text-base font-semibold uppercase tracking-wider text-brand-gold">Quick Links</h4>
          <ul className="space-y-2">
            {quickLinks.map(([label, href]) => (
              <li key={href}>
                <a href={href} className="text-base text-white/75 transition-colors hover:text-brand-gold">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Socials */}
        <div>
          <h4 className="mb-4 text-base font-semibold uppercase tracking-wider text-brand-gold">Follow Us</h4>
          <div className="flex gap-4 text-2xl">
            {socials.map(({ Icon, href }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/75 transition-colors hover:text-brand-gold"
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-5 text-center text-sm text-white/60">
        &copy; CHALO MAKKAH SHARIF {new Date().getFullYear()}. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
